import { computed } from 'vue';
import useFacets from './useFacets';

export default function useMySizes() {
  const {
    globalOptions,
  } = useFacets();

  const transformedMySizesData = computed(() => globalOptions.mySizesData.value?.selectedSizes?.map((facet) => ({
    name: facet.children[0].name,
    values: facet.values.filter((val) => val.personal),
  })) || []);

  const transformedSelectedMySizes = computed(() => transformedMySizesData.value.map((facet) => ({
    name: facet.name,
    selectedValues: facet.values.map((val) => val.value),
  })));

  return {
    transformedMySizesData,
    transformedSelectedMySizes,
    mySizesEnabled: globalOptions.mySizesData.value.enabled,
  };
}
